import {useUpmPlantsContext} from '@hconnect/upm'

import {useSuiteHierarchyId} from './useSuiteHierarchyId'

/**
 * Extracts the hierarchyId from the URL and validates it is a plant node.
 * Throws if hierarchyId is not found in the UPM plants dictionary
 * (i.e., it's a country/area/region/global node, not a plant).
 *
 * @returns plantUpmId — the hierarchyId confirmed to be a plant's UPM ID
 * @throws Error if hierarchyId is not in the URL
 * @throws Error if hierarchyId does not match any plant in UPM context
 */
export const usePlantUpmIdFromHierarchyId = (): string => {
  const hierarchyId = useSuiteHierarchyId()

  if (!hierarchyId) {
    throw new Error('usePlantUpmIdFromHierarchyId: No hierarchyId param provided in URL path.')
  }

  const plantsMap = useUpmPlantsContext()
  const plant = Object.values(plantsMap).find((p) => p.upmId === hierarchyId)

  if (!plant) {
    throw new Error(
      `usePlantUpmIdFromHierarchyId: hierarchyId "${hierarchyId}" is not a plant node.`
    )
  }

  return hierarchyId
}
